<div class="dash-content">

  <div class="page-header">
    <div>
      <h1>Dashboard Operacional</h1>
      <p>Visão geral das operações de segurança</p>
    </div>

    <div class="page-actions">
      <button
        class="btn-web-secondary"
        (click)="exportarDashboard()"
        
      >
        <i class="fas fa-file-export"></i>
        Exportar
      </button>

      <button
        class="btn-web-primary"
        (click)="abrirModalOcorrencia()"
      >
        <i class="fas fa-plus"></i>
        Nova Ocorrência
      </button>
    </div>
  </div>


  <!-- ════════════════════════════════════════════════════
       ALERTS STRIP
       ════════════════════════════════════════════════════ -->
  @if (loading) {

    <div class="alerts-strip">

      <!-- Skeleton alerta 1 -->
      <div class="alert-strip-item">
        <p-skeleton
          shape="circle"
          width="32px"
          height="32px"
        ></p-skeleton>

        <div style="flex: 1">
          <p-skeleton
            width="80px"
            height="14px"
            styleClass="mb-2"
          ></p-skeleton>

          <p-skeleton
            width="120px"
            height="12px"
          ></p-skeleton>
        </div>

        <p-skeleton
          width="45px"
          height="12px"
        ></p-skeleton>
      </div>

      <!-- Skeleton alerta 2 -->
      <div class="alert-strip-item">
        <p-skeleton
          shape="circle"
          width="32px"
          height="32px"
        ></p-skeleton>

        <div style="flex: 1">
          <p-skeleton
            width="70px"
            height="14px"
            styleClass="mb-2"
          ></p-skeleton>

          <p-skeleton
            width="130px"
            height="12px"
          ></p-skeleton>
        </div>

        <p-skeleton
          width="45px"
          height="12px"
        ></p-skeleton>
      </div>

      <!-- Skeleton alerta 3 -->
      <div class="alert-strip-item">
        <p-skeleton
          shape="circle"
          width="32px"
          height="32px"
        ></p-skeleton>

        <div style="flex: 1">
          <p-skeleton
            width="90px"
            height="14px"
            styleClass="mb-2"
          ></p-skeleton>

          <p-skeleton
            width="110px"
            height="12px"
          ></p-skeleton>
        </div>

        <p-skeleton
          width="45px"
          height="12px"
        ></p-skeleton>
      </div>

      <!-- Ver todos -->
      <div class="alert-strip-item">
        <p-skeleton
          shape="circle"
          width="32px"
          height="32px"
        ></p-skeleton>

        <div style="flex: 1">
          <p-skeleton
            width="140px"
            height="14px"
            styleClass="mb-2"
          ></p-skeleton>

          <p-skeleton
            width="100px"
            height="12px"
          ></p-skeleton>
        </div>

        <p-skeleton
          width="30px"
          height="12px"
        ></p-skeleton>
      </div>

    </div>

  } @else {

    <div class="alerts-strip">

      @if (postosSemCobertura.length > 0) {
        <div
          class="alert-strip-item critical pulse-border-red"
          routerLink="/admin/postos"
        >
          <i class="fas fa-circle-exclamation pulse-anim"></i>

          <div>
            <strong>
              {{ postosSemCobertura.length }}
              {{ postosSemCobertura.length === 1 ? "Posto" : "Postos" }}
            </strong>

            <span>Sem cobertura</span>
          </div>

          <span class="alert-strip-time">
            Agora
          </span>
        </div>
      }

      @if (armasCount > 0) {
        <div
          class="alert-strip-item warn pulse-border-yellow"
          routerLink="/admin/equipamentos"
        >
          <i class="fas fa-gun pulse-anim"></i>

          <div>
            <strong>
              {{ armasCount }}
              {{ armasCount === 1 ? "Arma" : "Armas" }}
            </strong>

            <span>Requerem manutenção</span>
          </div>

          <span class="alert-strip-time">
            Hoje
          </span>
        </div>
      }

      @if (faturasCount > 0) {
        <div
          class="alert-strip-item warn pulse-border-blue"
          routerLink="/admin/financeiro"
        >
          <i class="fas fa-file-invoice"></i>

          <div>
            <strong>
              {{ faturasCount }}
              {{ faturasCount === 1 ? "Fatura" : "Faturas" }}
            </strong>

            <span>Em atraso</span>
          </div>

          <span class="alert-strip-time">
            Hoje
          </span>
        </div>
      }

      @if (viaturasCount > 0) {
        <div
          class="alert-strip-item warn pulse-border-yellow"
          routerLink="/admin/equipamentos"
        >
          <i class="fas fa-car"></i>

          <div>
            <strong>
              {{ viaturasCount }}
              {{ viaturasCount === 1 ? "Viatura" : "Viaturas" }}
            </strong>

            <span>Revisão pendente</span>
          </div>

          <span class="alert-strip-time">
            Ontem
          </span>
        </div>
      }

      <a
        routerLink="/admin/alertas"
        class="alert-strip-item medium"
      >
        <i class="fas fa-bell"></i>

        <div>
          <strong>Ver todos os alertas</strong>
          <span>Centro de alertas →</span>
        </div>

        <span class="alert-strip-time">
          Ver
        </span>
      </a>

    </div>

  }


  <!-- ════════════════════════════════════════════════════
       KPI GRID — 6 CARDS
       ════════════════════════════════════════════════════ -->
  <div class="kpi-grid kpi-6">

    <!-- 1. POSTOS ATIVOS -->
    <div
      class="kpi-card"
      routerLink="/admin/postos"
    >

      <div class="kpi-icon green">
        <i class="fas fa-map-marker-alt"></i>
      </div>

      <div class="kpi-info">

        <span>Postos Ativos</span>

        @if (loading) {

          <p-skeleton
            width="70px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-mini-bar">
            <p-skeleton
              width="100%"
              height="6px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ postosAtivos }}
          </strong>

          <div class="kpi-mini-bar">
            <div
              class="bar-green"
              [style.width]="(kpis[1].percentage ?? 0) + '%'"
            ></div>
          </div>

        }

      </div>
    </div>


    <!-- 2. EFETIVOS EM SERVIÇO -->
    <div
      class="kpi-card"
      routerLink="/admin/efetivos"
    >

      <div class="kpi-icon blue">
        <i class="fas fa-users"></i>
      </div>

      <div class="kpi-info">

        <span>Efetivos em Serviço</span>

        @if (loading) {

          <p-skeleton
            width="80px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-mini-bar">
            <p-skeleton
              width="100%"
              height="6px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ efetivosEmServico }}
          </strong>

          <div class="kpi-mini-bar">
            <div
              class="bar-blue"
              [style.width]="(kpis[0].percentage ?? 0) + '%'"
            ></div>
          </div>

        }

      </div>
    </div>


    <!-- 3. OCORRÊNCIAS ABERTAS -->
    <div
      class="kpi-card"
      routerLink="/admin/ocorrencias"
    >

      <div class="kpi-icon red">
        <i class="fas fa-triangle-exclamation"></i>
      </div>

      <div class="kpi-info">

        <span>Ocorrências Abertas</span>

        @if (loading) {

          <p-skeleton
            width="70px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-sub-info">
            <p-skeleton
              width="100px"
              height="12px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ ocorrenciasAbertas }}
          </strong>

          <div class="kpi-sub-info">
            <span class="red-text">
              Alta prioridade
            </span>
          </div>

        }

      </div>

      @if (!loading) {
        <div class="kpi-trend neutral">
          <i class="fas fa-minus"></i>
          Hoje
        </div>
      } @else {
        <p-skeleton
          width="45px"
          height="20px"
        ></p-skeleton>
      }

    </div>


    <!-- 4. EQUIPAMENTOS EM MANUTENÇÃO -->
    <div
      class="kpi-card"
      routerLink="/admin/equipamentos"
    >

      <div class="kpi-icon yellow">
        <i class="fas fa-shield-alt"></i>
      </div>

      <div class="kpi-info">

        <span>Equip. Manutenção</span>

        @if (loading) {

          <p-skeleton
            width="70px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-sub-info">
            <p-skeleton
              width="100px"
              height="12px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ equipamentosEmManutencao }}
          </strong>

          <div class="kpi-sub-info">
            <span class="yellow-text">
              Viaturas · Armas
            </span>
          </div>

        }

      </div>

      @if (!loading) {

        <div class="kpi-trend neutral">
          <i class="fas fa-exclamation"></i>
          Atenção
        </div>

      } @else {

        <p-skeleton
          width="60px"
          height="20px"
        ></p-skeleton>

      }

    </div>


    <!-- 5. CONTRATOS A VENCER -->
    <div
      class="kpi-card"
      routerLink="/admin/financeiro"
    >

      <div class="kpi-icon red">
        <i class="fas fa-coins"></i>
      </div>

      <div class="kpi-info">

        <span>Contratos a Vencer</span>

        @if (loading) {

          <p-skeleton
            width="70px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-sub-info">
            <p-skeleton
              width="80px"
              height="12px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ contratosAVencer }}
          </strong>

          <div class="kpi-sub-info">
            <span class="red-text">
              Em atraso
            </span>
          </div>

        }

      </div>
    </div>


    <!-- 6. ALERTAS ATIVOS -->
    <div
      class="kpi-card"
      routerLink="/admin/alertas"
    >

      <div class="kpi-icon purple">
        <i class="fas fa-bell"></i>
      </div>

      <div class="kpi-info">

        <span>Alertas Ativos</span>

        @if (loading) {

          <p-skeleton
            width="70px"
            height="30px"
            styleClass="my-2"
          ></p-skeleton>

          <div class="kpi-sub-info">
            <p-skeleton
              width="140px"
              height="12px"
            ></p-skeleton>
          </div>

        } @else {

          <strong>
            {{ alertasAtivos }}
          </strong>

          <div class="kpi-sub-info">
            <span class="red-text">
              Postos sem cobertura
            </span>
          </div>

        }

      </div>

      @if (loading) {

        <p-skeleton
          width="40px"
          height="20px"
        ></p-skeleton>

      } @else {

        @if (postosSemCobertura.length > 0) {
          <div class="kpi-trend down pulse-anim">
            <i class="fas fa-circle-exclamation"></i>
            Ver
          </div>
        }

      }

    </div>

  </div>


  <!-- ════════════════════════════════════════════════════
       CHARTS ROW 1
       ════════════════════════════════════════════════════ -->
  <div class="charts-row-2">

    <!-- ═══════════════════════════════════════════════════
         OCORRÊNCIAS POR CRITICIDADE
         ═══════════════════════════════════════════════════ -->
    <div class="chart-card">

      <div class="chart-card-header">

        <h3>
          <i class="fas fa-chart-bar"></i>
          Ocorrências por Criticidade

          <small
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 400;
              margin-left: 4px;
            "
          >
            (30 dias)
          </small>
        </h3>

      </div>

      <div class="chart-wrap">

        @if (loading) {

          <div
            style="
              width: 100%;
              height: 220px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 18px;
              padding: 20px;
            "
          >

            <p-skeleton
              width="85%"
              height="22px"
            ></p-skeleton>

            <p-skeleton
              width="65%"
              height="22px"
            ></p-skeleton>

            <p-skeleton
              width="45%"
              height="22px"
            ></p-skeleton>

          </div>

        } @else {

          @if (ocorrenciasPorCriticidade.length === 0) {

            <div class="dash-empty">
              <i class="fas fa-chart-bar"></i>
              <p>Sem ocorrências por criticidade</p>
            </div>

          } @else {

            <p-chart
              type="bar"
              [data]="criticidadeData"
              [options]="criticidadeOptions"
              height="220px"
            ></p-chart>

          }

        }

      </div>

    </div>


    <!-- ═══════════════════════════════════════════════════
         POSTOS POR NÍVEL DE RISCO
         ═══════════════════════════════════════════════════ -->
    <div class="chart-card">

      <div class="chart-card-header">

        <h3>
          <i class="fas fa-chart-pie"></i>
          Postos por Nível de Risco
        </h3>

      </div>

      <div class="chart-wrap">

        @if (loading) {

          <div
            style="
              width: 100%;
              height: 220px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >

            <p-skeleton
              shape="circle"
              width="180px"
              height="180px"
            ></p-skeleton>

          </div>

        } @else {

          @if (postosPorNivelRisco.length === 0) {

            <div class="dash-empty">
              <i class="fas fa-chart-pie"></i>
              <p>Sem dados de risco dos postos</p>
            </div>

          } @else {

            <p-chart
              type="doughnut"
              [data]="riscoData"
              [options]="riscoOptions"
              height="220px"
            ></p-chart>

          }

        }

      </div>

    </div>

  </div>


  <!-- ════════════════════════════════════════════════════
       TABLES ROW
       ════════════════════════════════════════════════════ -->
  <div class="charts-row-2">

    <!-- ═══════════════════════════════════════════════════
         ESCALAS DE HOJE
         ═══════════════════════════════════════════════════ -->
    <div class="chart-card">

      <div class="chart-card-header">

        <h3>
          <i class="fas fa-calendar-check"></i>
          Escalas de Hoje
        </h3>

        <a
          routerLink="/admin/escalas"
          class="btn-web-secondary"
          style="padding: 5px 12px; font-size: 12px"
        >
          Ver todas
        </a>

      </div>


      @if (loading) {

        <div class="dash-table-wrap">

          <table class="dash-table">

            <thead>
              <tr>
                <th>Posto</th>
                <th>Turno</th>
                <th>Horário</th>
                <th>Efetivos</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>

              @for (item of [1, 2, 3, 4, 5]; track item) {

                <tr>

                  <td>
                    <p-skeleton
                      width="100px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="80px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="100px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="40px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="70px"
                      height="22px"
                    ></p-skeleton>
                  </td>

                </tr>

              }

            </tbody>

          </table>

        </div>

      } @else {

        @if (escalasDeHoje.length === 0) {

          <div class="dash-empty">
            <i class="fas fa-calendar-xmark"></i>
            <p>Sem escalas registadas para hoje</p>
          </div>

        } @else {

          <div class="dash-table-wrap">

            <table class="dash-table">

              <thead>
                <tr>
                  <th>Posto</th>
                  <th>Turno</th>
                  <th>Horário</th>
                  <th>Efetivos</th>
                  <th>Estado</th>
                </tr>
              </thead>

              <tbody>

                @for (e of escalasDeHoje; track e.id) {

                  <tr>

                    <td>
                      {{ e.postoNome }}
                    </td>

                    <td>
                      {{ e.turnoNome }}
                    </td>

                    <td>
                      {{ e.dataInicio | date: "HH:mm" }}
                      -
                      {{ e.dataTermino | date: "HH:mm" }}
                    </td>

                    <td>
                      {{ e.totalEfetivos }}
                    </td>

                    <td>
                      <span class="status-badge">
                        {{ e.estadoDescricao }}
                      </span>
                    </td>

                  </tr>

                }

              </tbody>

            </table>

          </div>

        }

      }

    </div>


    <!-- ═══════════════════════════════════════════════════
         ÚLTIMAS OCORRÊNCIAS
         ═══════════════════════════════════════════════════ -->
    <div class="chart-card">

      <div class="chart-card-header">

        <h3>
          <i class="fas fa-triangle-exclamation"></i>
          Últimas Ocorrências
        </h3>

        <a
          routerLink="/admin/ocorrencias"
          class="btn-web-secondary"
          style="padding: 5px 12px; font-size: 12px"
        >
          Ver todas
        </a>

      </div>


      @if (loading) {

        <div class="dash-table-wrap">

          <table class="dash-table">

            <thead>
              <tr>
                <th>#</th>
                <th>Tipo</th>
                <th>Posto</th>
                <th>Criticidade</th>
                <th>Data</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>

              @for (item of [1, 2, 3, 4, 5]; track item) {

                <tr>

                  <td>
                    <p-skeleton
                      width="35px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="80px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="100px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="70px"
                      height="22px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="110px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                  <td>
                    <p-skeleton
                      width="70px"
                      height="16px"
                    ></p-skeleton>
                  </td>

                </tr>

              }

            </tbody>

          </table>

        </div>

      } @else {

        @if (ultimasOcorrenciasApi.length === 0) {

          <div class="dash-empty">
            <i class="fas fa-shield-check"></i>
            <p>Sem ocorrências recentes</p>
          </div>

        } @else {

          <div class="dash-table-wrap">

            <table class="dash-table">

              <thead>
                <tr>
                  <th>#</th>
                  <th>Tipo</th>
                  <th>Posto</th>
                  <th>Criticidade</th>
                  <th>Data</th>
                  <th>Estado</th>
                </tr>
              </thead>

              <tbody>

                @for (o of ultimasOcorrenciasApi; track o.id) {

                  <tr>

                    <td class="mono">
                      {{ o.id }}
                    </td>

                    <td>
                      {{ o.tipo }}
                    </td>

                    <td>
                      {{ o.postoNome }}
                    </td>

                    <td>
                      <app-status-badge
                        [value]="o.criticidade"
                        type="criticidade"
                      ></app-status-badge>
                    </td>

                    <td>
                      {{ o.dataOcorrencia | date: "dd/MM/yy HH:mm" }}
                    </td>

                    <td>
                      {{ o.estado }}
                    </td>

                  </tr>

                }

              </tbody>

            </table>

          </div>

        }

      }

    </div>

  </div>

</div>